module.exports = __webpack_public_path__ + "media/images/sp/reports/main_visual_02-54172c440935d0e38942e070892203d4.jpg";